
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("5nBzc", function(module, exports) {
/* lozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

/* lozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $dKLHc = parcelRequire("dKLHc");

/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $e50b8329b0553dbf$var$Lozenge = ({ appearance: appearance = 'neutral', maxWidth: maxWidth = 200, style: style, testId: testId, children: children, iconBefore: iconBefore })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dKLHc.default), {
        appearance: appearance,
        iconBefore: iconBefore,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        testId: testId,
        children: children
    });
};
$e50b8329b0553dbf$var$Lozenge.displayName = 'Lozenge';
var $e50b8329b0553dbf$export$2e2bcd8739ae039 = $e50b8329b0553dbf$var$Lozenge;


const $dca450adfa76ae0a$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
const $dca450adfa76ae0a$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
const $dca450adfa76ae0a$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
const $dca450adfa76ae0a$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
const $dca450adfa76ae0a$var$LegacyLozenge = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $42omo.useMemo)(()=>$dca450adfa76ae0a$var$appearanceTypes.includes(appearance) || $dca450adfa76ae0a$var$newSemanticColors.includes(appearance) ? $dca450adfa76ae0a$var$appearanceMapping[appearance] : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $dca450adfa76ae0a$var$styles.container,
            $dca450adfa76ae0a$var$styles[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && $dca450adfa76ae0a$var$styles[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && $dca450adfa76ae0a$var$styles.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $gMc0m.default)([
                $dca450adfa76ae0a$var$styles.text,
                (0, $dh538.fg)('platform-lozenge-custom-letterspacing') && $dca450adfa76ae0a$var$styles.customLetterspacing,
                $dca450adfa76ae0a$var$styles[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
});
$dca450adfa76ae0a$var$LegacyLozenge.displayName = 'Lozenge'; /**
                                        * Wrapper component that switches between old and new Lozenge based on feature flag
                                        */ 
const $dca450adfa76ae0a$var$LozengeWrapper = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    if ((0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $e50b8329b0553dbf$export$2e2bcd8739ae039), {
        ...props
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($dca450adfa76ae0a$var$LegacyLozenge, {
        ...props
    });
});
$dca450adfa76ae0a$var$LozengeWrapper.displayName = 'Lozenge';
var $dca450adfa76ae0a$export$2e2bcd8739ae039 = $dca450adfa76ae0a$var$LozengeWrapper;
module.exports["default"] = $dca450adfa76ae0a$export$2e2bcd8739ae039;

});

parcelRegister("dKLHc", function(module, exports) {
/* lozenge-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $ghftu = parcelRequire("ghftu");


var $2W0qg = parcelRequire("2W0qg");




parcelRequire("42omo");

// Map lozenge colors to appropriate icon colors
const $398b25942ffd103f$var$getIconColor = (color, isSelected)=>{
    // When lozenge is selected and interactive, use selected text color for consistency
    if (isSelected) return "var(--ds-icon-selected, #1868DB)";
    // For semantic colors, use corresponding semantic text colors
    switch(color){
        case 'success':
            return "var(--ds-icon-success, #6A9A23)";
        case 'warning':
            return "var(--ds-icon-warning, #E06C00)";
        case 'danger':
            return "var(--ds-icon-danger, #C9372C)";
        case 'information':
            return "var(--ds-icon-information, #357DE8)";
        case 'neutral':
            return "var(--ds-icon-subtlest, #6B6E76)";
        case 'discovery':
            return "var(--ds-icon-discovery, #AF59E1)";
        // For accent colors, use corresponding accent icon colors
        case 'accent-red':
            return "var(--ds-icon-accent-red, #C9372C)";
        case 'accent-orange':
            return "var(--ds-icon-accent-orange, #E06C00)";
        case 'accent-yellow':
            return "var(--ds-icon-accent-yellow, #B38600)";
        case 'accent-lime':
            return "var(--ds-icon-accent-lime, #6A9A23)";
        case 'accent-green':
            return "var(--ds-icon-accent-green, #22A06B)";
        case 'accent-teal':
            return "var(--ds-icon-accent-teal, #2898BD)";
        case 'accent-blue':
            return "var(--ds-icon-accent-blue, #357DE8)";
        case 'accent-purple':
            return "var(--ds-icon-accent-purple, #AF59E1)";
        case 'accent-magenta':
            return "var(--ds-icon-accent-magenta, #CD519D)";
        case 'accent-gray':
            return "var(--ds-icon-accent-gray, #7D818A)";
        default:
            return "var(--ds-icon-subtlest, #6B6E76)";
    }
};
const $398b25942ffd103f$export$32ff197eed95e568 = ({ icon: Icon, color: color, isSelected: isSelected, testId: testId })=>{
    const iconColor = $398b25942ffd103f$var$getIconColor(color, isSelected);
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        color: iconColor,
        label: "",
        size: "small",
        testId: testId
    });
};
var $398b25942ffd103f$export$2e2bcd8739ae039 = $398b25942ffd103f$export$32ff197eed95e568;


// Map legacy appearance to new color values
const $99bcbfdffa078f04$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
const $99bcbfdffa078f04$export$acf5d2b7dc999bda = (appearance = 'neutral')=>{
    if (appearance.startsWith('accent-')) return appearance;
    return $99bcbfdffa078f04$var$legacyAppearanceMap[appearance] ?? appearance;
};
const $99bcbfdffa078f04$export$a3fc04b8551e006a = (resolvedColor)=>{
    const isAccent = resolvedColor.startsWith('accent-');
    const category = isAccent ? 'accent' : 'semantic';
    const key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};


const $b79a7ce738636669$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _zulp1b66 _1rjcv77o _18zr1b66 _189ee4h9 _1dqonqa1 _1h6d1j28 _1e0c116y _4cvr1h6o _vchhusvi _4t3igktf",
    containerInteractive: "_80omtlke _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa",
    containerSelected: "_bfhk15s3 _syaz6x5g _irr3ufnl _1di6nozp",
    text: "_11c8wadc _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    textSelected: "_syaz6x5g",
    'semantic.success': "_1b3i4pcx _3wu01mps _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_1b3iervl _3wu01xiv _bfhk10f4 _syazmgs1",
    'semantic.danger': "_1b3is4qr _3wu01bqt _bfhk18wg _syaz1blx",
    'semantic.information': "_1b3iyhbg _3wu0vbh5 _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_1b3i1cv2 _3wu01ihb _bfhki8nm _syazi7uo",
    'semantic.discovery': "_1b3iqm1h _3wu0v30g _bfhke670 _syaz1g72",
    'accent.red': "_1b3inbxb _3wu016y8 _bfhk1rtt _syazhwvp",
    'accent.orange': "_1b3i1j6y _3wu01b2s _bfhk165s _syaz7i1p",
    'accent.yellow': "_1b3i1oqg _3wu0feiv _bfhk1773 _syazekll",
    'accent.lime': "_1b3i8645 _3wu0nf89 _bfhkz2ec _syaz1ik3",
    'accent.green': "_1b3i17hp _3wu01crs _bfhk1wnw _syaz1y78",
    'accent.teal': "_1b3i8uof _3wu01h3o _bfhk1a17 _syaz12v7",
    'accent.blue': "_1b3i6txe _3wu01w55 _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_1b3iuq3u _3wu01hqq _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_1b3iv8hk _3wu0uwd0 _bfhkv9ra _syaz1qur",
    'accent.gray': "_1b3i1diz _3wu08yml _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    selectedInteractive: "_irr3ufnl _1di6nozp",
    iconBorderFilter: "_1h6dzs9d _4uq11yqs _1k671038 _m71tr3uz _13muu67f _168qx19p _oe6mmko7 _189qkb7n _u8p61h4e _1t75u67f _hg5mr3uz _1f28f1ug _1xe213rw _1easxmrh _1r9r1ss3",
    iconBorderInteractiveFilter: "_1iel6xdd _111i1h4e _18dicjiy _hyog26zw _fdt01r5k _46v5hwvj _ylgq1r5k _bg3q9by0 _196p1btq _18mn783i _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _4cvx7ddx _1cp21w66 _q4zt1csi _1gqs1mvc _75gv2l9f _1lh71sfd _ui3h1ct7 _11o31cha"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ const $b79a7ce738636669$var$LozengeBase = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, maxWidth: maxWidth = 200, isSelected: isSelected, onClick: // for dropdown trigger
onClick, style: // for dropdown trigger
style, analyticsContext: analyticsContext, interactionName: interactionName }, ref)=>{
    const isInteractive = typeof onClick === 'function'; // Determine the effective color, with fallback logic for legacy appearances
    const resolvedColor = (0, $99bcbfdffa078f04$export$acf5d2b7dc999bda)(appearance) || 'neutral';
    const { category: category, key: key } = (0, $99bcbfdffa078f04$export$a3fc04b8551e006a)(resolvedColor);
    const colorStyleKey = `${category}.${key}`;
    const interactiveStyleKey = `interactive.${category}.${key}`;
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    const commonStyleOverrides = {
        backgroundColor: style?.backgroundColor,
        maxWidth: maxWidthIsPc ? maxWidth : '100%'
    };
    const innerContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            iconBefore && /*#__PURE__*/ (0, $l998X.jsx)((0, $398b25942ffd103f$export$2e2bcd8739ae039), {
                icon: iconBefore,
                color: resolvedColor,
                isSelected: isInteractive ? isSelected : undefined,
                testId: testId && `${testId}--icon`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                style: {
                    maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`,
                    color: style?.color
                },
                "data-testid": testId && `${testId}--text`,
                className: (0, $gMc0m.default)([
                    $b79a7ce738636669$var$styles.text
                ]),
                children: children
            }),
            isInteractive && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                size: "small",
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : 'currentColor',
                testId: testId && `${testId}--chevron`
            })
        ]
    });
    if (isInteractive) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        ref: ref,
        xcss: (0, $1Whri.cx)($b79a7ce738636669$var$styles.container, !isSelected && $b79a7ce738636669$var$styles.iconBorderFilter, !isSelected && $b79a7ce738636669$var$styles.iconBorderInteractiveFilter, $b79a7ce738636669$var$styles[colorStyleKey], $b79a7ce738636669$var$styles[interactiveStyleKey], isSelected && $b79a7ce738636669$var$styles.containerSelected),
        onClick: onClick,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...commonStyleOverrides,
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? "var(--ds-border-selected, #1868DB)" : 'transparent'}`
        },
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger",
        children: innerContent
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $b79a7ce738636669$var$styles.container,
            $b79a7ce738636669$var$styles[colorStyleKey],
            $b79a7ce738636669$var$styles.iconBorderFilter
        ]),
        children: innerContent
    });
}));
var $b79a7ce738636669$export$2e2bcd8739ae039 = $b79a7ce738636669$var$LozengeBase;
module.exports["default"] = $b79a7ce738636669$export$2e2bcd8739ae039;

});

parcelRegister("c4sKh", function(module, exports) {
/* badge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");

/* badge-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 











function $1687c74e524fbc98$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $1687c74e524fbc98$export$4b844743568d5983(value, max) {
    const safeValue = $1687c74e524fbc98$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $1687c74e524fbc98$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $1687c74e524fbc98$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $1687c74e524fbc98$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $1687c74e524fbc98$var$getSafeValue(value);
    const safeMax = $1687c74e524fbc98$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


const $62caa3bc42101006$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral'
};
const $62caa3bc42101006$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default'
}; /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
// Nested selectors with data attributes are required for theme switching
const $62caa3bc42101006$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk1s9h _1ut5iv2r _1cn41hpu",
    danger: "_syaz1blx _bfhkrkii _1ut5zp7h _1cn484f9",
    warning: "_bfhk1kmu _syazmgs1 _15ua14ug _1cn4do2b",
    information: "_syaz1qd9 _bfhk1dq8 _1ut5e5eq _1cn4xr8b",
    discovery: "_syaz1g72 _bfhkiizu _1ut51bbx _1cn417oz",
    neutral: "_syazi7uo _bfhk7i23 _1ut5z5kg _1cn41g0e",
    inverse: "_bfhkvuon _syazi7uo"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
const $62caa3bc42101006$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, $1687c74e524fbc98$export$7c4d25c0c3217d8c)(children, max) : children;
}; /**
    * __BadgeNew__
    *
    * New visual refresh implementation of Badge component for the labelling system.
    * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
    *
    * Uses new appearance naming convention:
    * - success (green)
    * - danger (red)
    * - neutral (gray)
    * - information (blue)
    * - inverse (inverted colors)
    * - warning (orange/yellow)
    * - discovery (purple)
    */ 
const $62caa3bc42101006$var$BadgeNew = /*#__PURE__*/ (0, $42omo.memo)(function BadgeNew({ appearance: appearance = 'neutral', children: children = 0, max: max = 99, style: style, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $gMc0m.default)([
            $62caa3bc42101006$var$stylesNew.root,
            $62caa3bc42101006$var$stylesNew[appearance]
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $62caa3bc42101006$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $62caa3bc42101006$export$2e2bcd8739ae039 = $62caa3bc42101006$var$BadgeNew;



const $3633338e39044437$var$neutral300 = '#DDDEE1';
const $3633338e39044437$var$red300 = '#FD9891';
const $3633338e39044437$var$blue300 = '#8FB8F6';
const $3633338e39044437$var$neutral1000 = '#292A2E';
const $3633338e39044437$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
const $3633338e39044437$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && typeof max === 'number' ? (0, $1687c74e524fbc98$export$4b844743568d5983)(children, max) : children;
}; /**
    * __Badge__
    *
    * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
    *
    * - [Examples](https://atlassian.design/components/badge/examples)
    * - [Code](https://atlassian.design/components/badge/code)
    * - [Usage](https://atlassian.design/components/badge/usage)
    */ 
const $3633338e39044437$var$Badge = /*#__PURE__*/ (0, $42omo.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        const newAppearance = (0, $62caa3bc42101006$export$d21bba0569254935)[appearance];
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        /*#__PURE__*/ (0, $l998X.jsx)((0, $62caa3bc42101006$export$2e2bcd8739ae039), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId,
            children: children
        }));
    }
    const oldAppearance = (0, $62caa3bc42101006$export$16f8cc7ac3541e83)[appearance];
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $gMc0m.default)([
            $3633338e39044437$var$styles.root,
            $3633338e39044437$var$styles[oldAppearance]
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $3633338e39044437$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $3633338e39044437$export$2e2bcd8739ae039 = $3633338e39044437$var$Badge;
module.exports["default"] = $3633338e39044437$export$2e2bcd8739ae039;

});

parcelRegister("4noo5", function(module, exports) {
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $dh538 = parcelRequire("dh538");

const $934b3c00d8e6ad37$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
const $934b3c00d8e6ad37$var$inputMediaDisabled = null;
const $934b3c00d8e6ad37$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $934b3c00d8e6ad37$var$disabledStyle = {
    standard: "_1h6dby5v _bfhkby5v _syaz1gmx _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf"
};
const $934b3c00d8e6ad37$var$invalidStyle = null;
const $934b3c00d8e6ad37$var$focusWithinStyle = {
    standard: "_1p9x1v1w _qao9r01l _q433vyy1",
    subtle: "_1p9x1v1w _qao9r01l _q433vyy1",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
const $934b3c00d8e6ad37$var$hoverStyle = {
    standard: "_4cvxrsbi _irr3l4ek",
    subtle: "_4cvxrsbi _irr3l4ek",
    none: "_4cvx1j28 _irr31j28"
};
const $934b3c00d8e6ad37$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6drsbi _1dqonqa1 _syazi7uo _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syazi7uo _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syazi7uo _80om1kdv _16hg1j28 _msj6gir2"
};
const $934b3c00d8e6ad37$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $934b3c00d8e6ad37$var$getMaxWidth = (width)=>!width ? `100%` : width in $934b3c00d8e6ad37$var$widthMap ? `${$934b3c00d8e6ad37$var$widthMap[width]}px` : `${+width}px`;
const $934b3c00d8e6ad37$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $934b3c00d8e6ad37$var$containerStyles = null;
const $934b3c00d8e6ad37$var$containerStylesT26Shape = null;
const $934b3c00d8e6ad37$var$inputDisabledStyle = null;
const $934b3c00d8e6ad37$var$inputCompactStyle = null;
const $934b3c00d8e6ad37$var$inputMonospacedStyle = null; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textfield uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $934b3c00d8e6ad37$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $934b3c00d8e6ad37$var$Textfield = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $42omo.useRef)(null);
    const handleOnFocus = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934b3c00d8e6ad37$var$analyticsParams
    });
    const handleOnBlur = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934b3c00d8e6ad37$var$analyticsParams
    });
    const handleOnMouseDown = (0, $42omo.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $42omo.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$934b3c00d8e6ad37$var$getMaxWidth(width)}`
        },
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c8fhey _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnqfajl",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_1tnq1qi0",
            $934b3c00d8e6ad37$var$getContainerTextBgAndBorderColor[appearance],
            $934b3c00d8e6ad37$var$containerStyleAppearance[appearance],
            !isDisabled && $934b3c00d8e6ad37$var$focusWithinStyle[appearance],
            !isDisabled && $934b3c00d8e6ad37$var$hoverStyle[appearance],
            isDisabled && $934b3c00d8e6ad37$var$containerMedia.disabled,
            isDisabled && $934b3c00d8e6ad37$var$disabledStyle[appearance],
            isInvalid && $934b3c00d8e6ad37$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    "_19itidpf _11c81d4k _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr1rpy _1tn2fhey _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    isMonospaced && "_ect4zzfg _14mdzzfg",
                    isCompact && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isDisabled && "_syaz1gmx _1idr1gmx",
                    isDisabled && "_1fnx18qt"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $934b3c00d8e6ad37$export$2e2bcd8739ae039 = $934b3c00d8e6ad37$var$Textfield;
module.exports["default"] = $934b3c00d8e6ad37$export$2e2bcd8739ae039;

});

parcelRegister("aoVih", function(module, exports) {
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1qfLF = parcelRequire("1qfLF");


var $cO1el = parcelRequire("cO1el");


var $hmuev = parcelRequire("hmuev");


var $dh538 = parcelRequire("dh538");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");




parcelRequire("42omo");


var $3gddQ = parcelRequire("3gddQ");


var $a3fRD = parcelRequire("a3fRD");


var $eXmBZ = parcelRequire("eXmBZ");


var $3sFtD = parcelRequire("3sFtD");


var $ebrpi = parcelRequire("ebrpi");


var $6fnsQ = parcelRequire("6fnsQ");

const $3cc44aa8b598788e$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $6fnsQ.B50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $6fnsQ.B500)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $6fnsQ.Y50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $6fnsQ.Y500)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $6fnsQ.R50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $6fnsQ.R500)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $6fnsQ.G50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $6fnsQ.G500)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $6fnsQ.P50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gddQ))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $6fnsQ.P500)})`
    }
};
function $3cc44aa8b598788e$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $3cc44aa8b598788e$var$appearanceIconSchema[appearance] || $3cc44aa8b598788e$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ primaryColor: primaryColor })=>/*#__PURE__*/ (0, $l998X.jsx)(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}


const $e50f000c6973458a$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    containerT26Shape: "_2rko1mok",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
const $e50f000c6973458a$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
}; /**
    * __Section message__
    *
    * A section message is used to alert users to a particular section of the screen.
    *
    * - [Examples](https://atlassian.design/components/section-message/examples)
    * - [Code](https://atlassian.design/components/section-message/code)
    * - [Usage](https://atlassian.design/components/section-message/usage)
    */ 
const $e50f000c6973458a$var$SectionMessage = /*#__PURE__*/ (0, $42omo.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $42omo.useState)(false);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        onDismiss?.();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3cc44aa8b598788e$export$e9b82d2e21ac0c1f)(appearance, icon);
    const actionElements = actions && actions.type === (0, $42omo.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $42omo.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $l998X.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $gMc0m.default)([
            $e50f000c6973458a$var$sectionMessageStyles.container,
            (0, $dh538.fg)('platform-dst-shape-theme-default') && $e50f000c6973458a$var$sectionMessageStyles.containerT26Shape,
            $e50f000c6973458a$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $e50f000c6973458a$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $e50f000c6973458a$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                $e50f000c6973458a$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: $e50f000c6973458a$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $e50f000c6973458a$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$e50f000c6973458a$var$SectionMessage.displayName = 'SectionMessage';
var $e50f000c6973458a$export$2e2bcd8739ae039 = $e50f000c6973458a$var$SectionMessage;
module.exports["default"] = $e50f000c6973458a$export$2e2bcd8739ae039;

});

parcelRegister("abC4X", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $hArLp = parcelRequire("hArLp");


var $cO1el = parcelRequire("cO1el");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $9hlns = parcelRequire("9hlns");

/* actions-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $b6ec5e063c3a7af6$var$actionsStyles = null; /**
                             * __Actions container__
                             *
                             * A container for actions: primary action, secondary action, and tertiary action.
                             *
                             * @internal
                             */ 
const $b6ec5e063c3a7af6$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ]),
        children: children
    });
var $b6ec5e063c3a7af6$export$2e2bcd8739ae039 = $b6ec5e063c3a7af6$var$ActionsContainer;

/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $dc4c7d139f367f70$var$containerStyles = null; /* Use max-width so the component can shrink on smaller viewports. */ 
const $dc4c7d139f367f70$var$wideContainerStyles = null;
const $dc4c7d139f367f70$var$narrowContainerStyles = null;
const $dc4c7d139f367f70$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ]),
        children: children
    });
var $dc4c7d139f367f70$export$2e2bcd8739ae039 = $dc4c7d139f367f70$var$Container;

/* image.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $24e8f619b28ef148$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $24e8f619b28ef148$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $24e8f619b28ef148$var$imageStyles = null; /**
                           * __Image__
                           *
                           * Image in Empty State.
                           *
                           * @internal
                           */ 
const $24e8f619b28ef148$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $l998X.jsx)("img", {
        style: {
            [$24e8f619b28ef148$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$24e8f619b28ef148$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $gMc0m.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ])
    });
var $24e8f619b28ef148$export$2e2bcd8739ae039 = $24e8f619b28ef148$var$Image;

/* spinner-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $6eb5aa691ef9993b$var$spinnerContainerStyles = null; /**
                                      * __Spinner container__
                                      *
                                      * A spinner container for loading state of Empty State.
                                      *
                                      * @internal
                                      */ 
const $6eb5aa691ef9993b$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1bsb1ejb _ahbqpxbi"
        ]),
        children: children
    });
var $6eb5aa691ef9993b$export$2e2bcd8739ae039 = $6eb5aa691ef9993b$var$SpinnerContainer;


/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $9ab514c0df16f704$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, headingSize: headingSize = 'medium', imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $b6ec5e063c3a7af6$export$2e2bcd8739ae039), {
        children: [
            primaryAction && secondaryAction ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $hArLp.default), {
                label: buttonGroupLabel || 'Button group',
                testId: testId && `${testId}-button-group`,
                children: [
                    secondaryAction,
                    primaryAction
                ]
            }) : primaryAction || secondaryAction,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6eb5aa691ef9993b$export$2e2bcd8739ae039), {
                children: isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                    testId: "empty-state-spinner"
                })
            })
        ]
    }) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dc4c7d139f367f70$export$2e2bcd8739ae039), {
        testId: testId,
        width: width || 'wide',
        children: [
            imageUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $24e8f619b28ef148$export$2e2bcd8739ae039), {
                src: imageUrl,
                maxWidth: maxImageWidth,
                maxHeight: maxImageHeight,
                width: imageWidth,
                height: imageHeight
            }) : renderImage && renderImage({
                maxImageWidth: maxImageWidth,
                maxImageHeight: maxImageHeight,
                imageWidth: imageWidth,
                imageHeight: imageHeight
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                    size: headingSize,
                    as: tag,
                    children: header
                })
            }),
            description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                paddingBlockEnd: "space.300",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    as: "p",
                    children: description
                })
            }),
            actionsContainer,
            tertiaryAction
        ]
    });
};
var $9ab514c0df16f704$export$2e2bcd8739ae039 = $9ab514c0df16f704$var$EmptyState;
module.exports["default"] = $9ab514c0df16f704$export$2e2bcd8739ae039;

});

parcelRegister("ho4zm", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $bpQ0v = parcelRequire("bpQ0v");


var $8dG3J = parcelRequire("8dG3J");


var $kHF6o = parcelRequire("kHF6o");


var $4009b = parcelRequire("4009b");


var $lJT0z = parcelRequire("lJT0z");

const $3067586e5fba1d9c$var$SimpleTagComponent = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent, migration_fallback: migration_fallback, ...rest }, ref)=>{
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const lozengeAppearance = (0, $4009b.getLozengeAppearance)(color);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId,
            ...rest,
            children: text
        });
    }
    // Use new TagNew component behind feature flag
    if ((0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const newColor = (0, $bpQ0v.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $bpQ0v.default), {
            ref: ref,
            color: newColor,
            text: text,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: false
        });
    }
    // Original implementation
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $lJT0z.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8dG3J.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHF6o.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $3067586e5fba1d9c$var$SimpleTag = /*#__PURE__*/ (0, $42omo.memo)($3067586e5fba1d9c$var$SimpleTagComponent);
var $3067586e5fba1d9c$export$2e2bcd8739ae039 = $3067586e5fba1d9c$var$SimpleTag;
module.exports["default"] = $3067586e5fba1d9c$export$2e2bcd8739ae039;

});

parcelRegister("lUjjs", function(module, exports) {
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $fb3kw = parcelRequire("fb3kw");


var $fzqvY = parcelRequire("fzqvY");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");


var $6F6hl = parcelRequire("6F6hl");

/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 


parcelRequire("42omo");





var $1qfLF = parcelRequire("1qfLF");


var $cvXh8 = parcelRequire("cvXh8");


var $hmuev = parcelRequire("hmuev");




const $a923a768f1bc2446$var$buttonsContainerStyles = null;
const $a923a768f1bc2446$var$buttonWrapperBaseStyles = null;
const $a923a768f1bc2446$var$buttonWrapperBaseStylesT26Shape = null;
const $a923a768f1bc2446$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                tabIndex: -1,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _11c8fhey _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs130s _1mpy1b66 _1nlx1bhr _l2uv6o2t _7mfvm8nx _szlbi7uo",
                    (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                tabIndex: -1,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _11c8fhey _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs130s _1mpy1b66 _1nlx1bhr _l2uv6o2t _7mfvm8nx _szlbi7uo",
                    (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                            ...iconProps,
                            size: "small"
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $a923a768f1bc2446$export$2e2bcd8739ae039 = $a923a768f1bc2446$var$Buttons;





const $fc13fdba2a3cf0a9$var$usePrevious = (value)=>{
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $fc13fdba2a3cf0a9$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $42omo.useRef)(null);
    const editViewRef = (0, $42omo.useRef)();
    const preventFocusOnEditButtonRef = (0, $42omo.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $fc13fdba2a3cf0a9$var$usePrevious(shouldBeEditing);
    (0, $42omo.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $42omo.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $fc13fdba2a3cf0a9$export$2e2bcd8739ae039 = $fc13fdba2a3cf0a9$var$useButtonFocusHook;


/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 














const $35d9f9715033f1f7$var$readViewContainerStyles = null;
const $35d9f9715033f1f7$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189eidpf _1dqoglyw _1h6d1j28 _1e0c1ule _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _r06hglyw _bfhk1j28 _vwz4kb7n _1xp41v1w _14lydkaa _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $35d9f9715033f1f7$var$readViewWrapperStyles = null;
const $35d9f9715033f1f7$var$readViewWrapperStylesT26Shape = null;
const $35d9f9715033f1f7$var$readViewFitContainerWidthStyles = null;
const $35d9f9715033f1f7$var$DRAG_THRESHOLD = 5;
const $35d9f9715033f1f7$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $42omo.useRef)(0);
    const startY = (0, $42omo.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $35d9f9715033f1f7$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $35d9f9715033f1f7$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target; /**
                                                    * If a link is clicked in the read view, default action should be taken
                                                    */ 
        if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                xcss: $35d9f9715033f1f7$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div" /**
         * It is not normally acceptable to add click handlers to non-interactive elements
         * as this is an accessibility anti-pattern. However, because this instance is
         * account for clicking on links that may be embedded within inline-edit and not
         * creating an inaccessible custom element, we can add role="presentation" so that
         * there is no negative impacts to assistive technologies.
         * (Why links are embeeded in inline-edit is for another day...)
         */ , {
                role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _v564thzt _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr31dpa",
                    readViewFitContainerWidth && "_1bsb1osq",
                    (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0"
                ]),
                children: readView()
            })
        ]
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $35d9f9715033f1f7$export$2e2bcd8739ae039 = $35d9f9715033f1f7$var$ReadView;


const $639e5e6b0deeee6e$var$fieldStyles = null;
const $639e5e6b0deeee6e$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $639e5e6b0deeee6e$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $42omo.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $42omo.useState)(startWithEditViewOpen);
    const timerRef = (0, $42omo.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $fc13fdba2a3cf0a9$export$2e2bcd8739ae039)(isEditing, isEditingState);
    const onCancel = (0, $42omo.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $42omo.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$639e5e6b0deeee6e$var$analyticsAttributes
    });
    const onCancelClick = (0, $42omo.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $42omo.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        // Ignore if the provided ref is a function. This is used to make the
        // typechecking accurate. Inline edit only uses one type of ref, so this
        // will never trigger.
        if (typeof formRef === 'function') return;
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $42omo.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $42omo.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $35d9f9715033f1f7$export$2e2bcd8739ae039), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $l998X.jsx)("form" /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ , {
                role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                // This is because due to some default focus being applied to the form element, the inline edit component
                // was being focused automatically and causing scroll issues in issue view
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $dh538.fg)('platform_design_system_inline_edit_dont_focus') ? 'dont-default-focus' : undefined,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $l998X.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $gMc0m.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $l998X.jsx)((0, $a923a768f1bc2446$export$2e2bcd8739ae039), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view") : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view")
            })
    });
};
const $639e5e6b0deeee6e$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $l998X.jsx)($639e5e6b0deeee6e$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $639e5e6b0deeee6e$export$2e2bcd8739ae039 = $639e5e6b0deeee6e$var$InlineEdit;
module.exports["default"] = $639e5e6b0deeee6e$export$2e2bcd8739ae039;

});

parcelRegister("epp7s", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $024c7b240527c31b$var$rangeHeight = 40; // Height of the range input, used for the track and thumb
const $024c7b240527c31b$var$trackHeight = 6; // Height of the track, used for the track and thumb
const $024c7b240527c31b$var$thumbSize = "var(--ds-space-200, 16px)"; // Size of the thumb, used for the thumb styles
// Styles are split up to avoid edge-cases with TS implementations between `css` and `cssMap` with some
// of these edge-case pseudo-selectors.
// Previously, in Emotion, these selectors weren't consolidated, eg. `&::webkit-thumb, &::moz-thumb`
// would not be parsed by either browser, but this may no longer be the case in Compiled
const $024c7b240527c31b$var$webkitStyles = null;
const $024c7b240527c31b$var$firefoxStyles = null;
const $024c7b240527c31b$var$baseStyles = null;
const $024c7b240527c31b$var$themeStyles = null;
const $024c7b240527c31b$var$trackStyles = {
    root: "_1bsb1osq _4t3i1ylp _kqswh2mm _14mj1qll _1ywu1ule _z0ai1y44 _1qdg1y44 _18postnw _1hfkof27 _aetrb3bt _19nq1ssb _g0nfo1yi",
    disabled: "_1peq2wxo"
};
const $024c7b240527c31b$var$rangeA11yStyles = null;
const $024c7b240527c31b$var$stylesT26Shape = null;
const $024c7b240527c31b$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { valuePercent: valuePercent, style: style, ...strippedProps } = props;
    const input = /*#__PURE__*/ (0, $l998X.jsx)("input", {
        ...strippedProps,
        style: {
            // We are creating a css variable to control the "progress" portion of the range input
            // This avoids us needing to create a new css class for each new percentage value
            '--track-fg-width': `${valuePercent}%`
        },
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1ylp _bfhk1j28 _j5dh13gf _1j552wxo _nt751r31 _49pcglyw _1hvw1o36",
            "_wstuglyw _h2ksglyw _1kdl1qll _m8f8bpmo _1yz62hjt _1bdkusvi _u98zpxbi _1j70pxbi _1esf1w0t _4w431ik2 _yfyntlke _1sdc196n _18k7v77o _1cdcglyw _10lridpf _g6tdlb4i _vi4t2hjt _1g2h1osq _168l1y44 _9u3f2hce _1g741hsc _1d8tmgnk _np53xlkz _18tdtlke _1p201osq _1yte13gf _5i7a13gf",
            "_1yq0glyw _108m1qll _1rf3bpmo _1yeu2hjt _g4ppusvi _r763pxbi _1mn5pxbi _12el1w0t _1oqe1ik2 _10o7tlke _1kzev77o _15raidpf _e8hnidpf _37ywlb4i _1tcb2hjt _aoww1osq _1kd2i2wt _vt2s1w6o _1ssqtlke _ru37idpf _1gvolb4i _1nx42hjt _1f5t1osq _142y1y44 _d7w62hce _b3fmtlke _1vq313gf _1fov13gf _34m613gf",
            "_14h1b1q9 _15dpi8nm _18lx1aqn _jxar1ibz _ydqgplhp _1jhc1ibz _1rucof27 _164c1v1w",
            "_1drqof27 _15dp1vck _18lxof27 _g6tdfajl _168li2wt _37ywfajl _1kd2i2wt _1sdc1lpd _ydqgmpja",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_g6tdidpf _37ywidpf _1gvoidpf"
        ])
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $024c7b240527c31b$var$trackStyles.root,
            strippedProps.disabled && $024c7b240527c31b$var$trackStyles.disabled
        ]),
        children: input
    });
});
$024c7b240527c31b$export$f5b8910cec6cf069.displayName = 'InputRange';


const $e33d3ee04b17cdae$var$snapToStep = (value, min, step)=>{
    // Normalise the value to allow for division properly with different min values
    const adjustedValue = value - min;
    // Find the number of steps the value covers
    const numSteps = Math.round(adjustedValue / step);
    // Convert numSteps back into original range
    return numSteps * step + min;
};
const $e33d3ee04b17cdae$var$getRoundedPercentValue = (value, min, max, step)=>{
    let percent = '0';
    if (min < max && value > min) {
        const snappedValue = $e33d3ee04b17cdae$var$snapToStep(value, min, step);
        percent = ((snappedValue - min) / (max - min) * 100).toFixed(2);
    }
    return percent;
};
const $e33d3ee04b17cdae$var$noop = (0, $ee7An.default);
/**
 * __Range__
 *
 * A range lets users choose an approximate value on a slider.
 *
 * - [Examples](https://atlassian.design/components/range/examples)
 * - [Code](https://atlassian.design/components/range/code)
 * - [Usage](https://atlassian.design/components/range/usage)
 */ const $e33d3ee04b17cdae$var$Range = /*#__PURE__*/ (0, $42omo.forwardRef)(function Range(props, ref) {
    const { isDisabled: isDisabled = false, defaultValue: defaultValue = 50, max: max = 100, min: min = 0, onChange: onChange = $e33d3ee04b17cdae$var$noop, step: step = 1, value: propsValue, testId: testId, ...rest } = props;
    const spreadProps = {
        max: max,
        min: min,
        step: step,
        ref: ref,
        ...rest
    };
    const [value, setValue] = (0, $42omo.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const handleChange = (0, $42omo.useCallback)((e)=>{
        const newValue = Number(e.target.value);
        setValue(newValue);
        // Note use of newValue to ensure up=to-date value is used
        onChange(newValue);
    }, [
        onChange
    ]);
    const renderValue = propsValue !== undefined ? propsValue : value;
    const valuePercent = $e33d3ee04b17cdae$var$getRoundedPercentValue(renderValue, min, max, step);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $024c7b240527c31b$export$f5b8910cec6cf069), {
        type: "range",
        disabled: isDisabled,
        onChange: handleChange,
        value: renderValue,
        valuePercent: valuePercent,
        "data-testid": testId,
        ...spreadProps
    });
});
var $e33d3ee04b17cdae$export$2e2bcd8739ae039 = $e33d3ee04b17cdae$var$Range;
module.exports["default"] = $e33d3ee04b17cdae$export$2e2bcd8739ae039;

});

parcelRegister("82gXq", function(module, exports) {
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $cvXh8 = parcelRequire("cvXh8");


var $hmuev = parcelRequire("hmuev");


var $9hlns = parcelRequire("9hlns");


var $6F6hl = parcelRequire("6F6hl");

/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $90e7ba1d552f540d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $90e7ba1d552f540d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "span",
        xcss: (0, $1Whri.cx)($90e7ba1d552f540d$var$styles.iconContainer, isHidden && $90e7ba1d552f540d$var$styles.hidden, size === 'regular' && $90e7ba1d552f540d$var$styles.iconContainerRegular, size === 'large' && $90e7ba1d552f540d$var$styles.iconContainerLarge, position === 'left' && $90e7ba1d552f540d$var$styles.left, position === 'right' && $90e7ba1d552f540d$var$styles.right),
        children: children
    });
};
var $90e7ba1d552f540d$export$2e2bcd8739ae039 = $90e7ba1d552f540d$var$IconContainer;


const $cdaef5761c0348c7$var$LOADING_LABEL = ', Loading';
const $cdaef5761c0348c7$var$basicStyles = null;
const $cdaef5761c0348c7$var$sizeStyles = {
    regular: "_2rko1rr0 _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rko1rr0 _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $cdaef5761c0348c7$var$noop = (0, $ee7An.default);
const $cdaef5761c0348c7$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $cdaef5761c0348c7$var$Toggle = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $cdaef5761c0348c7$var$noop, onChange: providedChange = $cdaef5761c0348c7$var$noop, onFocus: providedFocus = $cdaef5761c0348c7$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $42omo.useState)(defaultChecked);
    const loadingLabelId = (0, $c0qxy.useId)();
    const handleBlur = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$cdaef5761c0348c7$var$analyticsAttributes
    });
    const handleFocus = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$cdaef5761c0348c7$var$analyticsAttributes
    });
    const handleChange = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$cdaef5761c0348c7$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const labelId = (0, $c0qxy.useId)();
    return /*#__PURE__*/ (0, $l998X.jsxs)("label", {
        ...controlProps,
        className: (0, $gMc0m.default)([
            "_v564kete _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh1ntv _kqswh2mm _1y1m1ntv _bfhk1aqn _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31qll _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1ys41v1w _krlfnqa1 _ju3ddkaa _1bkiby5v _1fltby5v _3xv2by5v _9471kcmj _ucab5w2r _mqf82sac _3dj22sac _1dl92sac _1div5w2r _1il8kb7n _y54d5w2r _irr31ibz _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1pluy7x8 _1uo81ibz _178cby5v _16rslghj _i5ec1w7i",
            $cdaef5761c0348c7$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $l998X.jsx)("span", {
                id: labelId,
                hidden: true,
                children: isLoading ? `${label}${$cdaef5761c0348c7$var$LOADING_LABEL}` : label
            }) : null,
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $90e7ba1d552f540d$export$2e2bcd8739ae039), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: isLoading && shouldChecked ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                    label: "",
                    color: "currentColor",
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $90e7ba1d552f540d$export$2e2bcd8739ae039), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: isLoading && !shouldChecked ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                    label: "",
                    color: "currentColor",
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            }),
            isLoading && !label && /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                id: loadingLabelId,
                children: $cdaef5761c0348c7$var$LOADING_LABEL
            })
        ]
    });
}));
$cdaef5761c0348c7$var$Toggle.displayName = 'Toggle';
var $cdaef5761c0348c7$export$2e2bcd8739ae039 = $cdaef5761c0348c7$var$Toggle;
module.exports["default"] = $cdaef5761c0348c7$export$2e2bcd8739ae039;

});

parcelRegister("iHPbg", function(module, exports) {
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");


var $1Whri = parcelRequire("1Whri");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");

const $25d55444a3e209b4$var$styles = {
    common: "_11c8fhey",
    anchor: "_k48pi7a9",
    pressable: "_syaz13af _k48p1wq8 _bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $25d55444a3e209b4$var$SectionMessageAction = /*#__PURE__*/ (0, $42omo.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }) {
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ (0, $l998X.jsx)("span", {
            className: (0, $gMc0m.default)([
                $25d55444a3e209b4$var$styles.common,
                $25d55444a3e209b4$var$styles.anchor
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                testId: testId,
                onClick: onClick,
                href: href,
                target: target,
                children: children
            })
        });
        if (onClick) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $1Whri.cx)($25d55444a3e209b4$var$styles.common, $25d55444a3e209b4$var$styles.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            as: "span",
            testId: testId,
            xcss: $25d55444a3e209b4$var$styles.common,
            children: children
        });
    } // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: children
    });
});
var $25d55444a3e209b4$export$2e2bcd8739ae039 = $25d55444a3e209b4$var$SectionMessageAction;
module.exports["default"] = $25d55444a3e209b4$export$2e2bcd8739ae039;

});

parcelRegister("3WVxj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $Asv1P = parcelRequire("Asv1P");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $5nBzc = parcelRequire("5nBzc");


var $g9Srd = parcelRequire("g9Srd");

var $8DMug = parcelRequire("8DMug");


var $dh538 = parcelRequire("dh538");


var $bpQ0v = parcelRequire("bpQ0v");


var $8dG3J = parcelRequire("8dG3J");


var $kHF6o = parcelRequire("kHF6o");


var $4009b = parcelRequire("4009b");


var $lJT0z = parcelRequire("lJT0z");


var $jCd35 = parcelRequire("jCd35");

const $c7d700dd6b7beca2$var$textLinkCssVar = '--ds-ctl';
const $c7d700dd6b7beca2$var$textDefaultCssVar = '--ds-ct';
const $c7d700dd6b7beca2$var$textActiveCssVar = '--ds-ctp';
const $c7d700dd6b7beca2$var$backgroundHoverCssVar = '--ds-cbh';
const $c7d700dd6b7beca2$var$backgroundActiveCssVar = '--ds-cba';
var $c7d700dd6b7beca2$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($c7d700dd6b7beca2$var$TagStatus || {});
const $c7d700dd6b7beca2$var$packageName = "platform-pkg";
const $c7d700dd6b7beca2$var$packageVersion = "0.0.0-use.local";
const $c7d700dd6b7beca2$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $c7d700dd6b7beca2$var$removingStyles = null;
const $c7d700dd6b7beca2$var$RemovableTagComponent = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $c7d700dd6b7beca2$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $ee7An.default), linkComponent: linkComponent, migration_fallback: migration_fallback, ...rest }, ref)=>{
    const [status, setStatus] = (0, $42omo.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $42omo.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $Asv1P.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $c7d700dd6b7beca2$var$packageName,
            packageVersion: $c7d700dd6b7beca2$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $42omo.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $42omo.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $42omo.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $42omo.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $42omo.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $42omo.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $42omo.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $l998X.jsx)((0, $jCd35.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined; // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const lozengeAppearance = (0, $4009b.getLozengeAppearance)(color);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId,
            ...rest,
            children: text
        });
    } // Use new TagNew component behind feature flag
    if ((0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const newColor = (0, $bpQ0v.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $bpQ0v.default), {
            ref: ref,
            color: newColor,
            text: text,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveAction
        });
    } // Original implementation
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $lJT0z.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        // Tag background color on hover
        [$c7d700dd6b7beca2$var$backgroundHoverCssVar]: undefined,
        // Tag background color on press
        [$c7d700dd6b7beca2$var$backgroundActiveCssVar]: undefined,
        // The tag text on hover of remove button
        [$c7d700dd6b7beca2$var$textDefaultCssVar]: undefined,
        // 'elemBefore' text on press of remove button
        [$c7d700dd6b7beca2$var$textActiveCssVar]: undefined,
        // The tag link text on hover of remove button
        [$c7d700dd6b7beca2$var$textLinkCssVar]: undefined
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $l998X.jsx)((0, $8DMug.default), {
            children: (motion)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $8dG3J.default), {
                    ref: (0, $3654r.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHF6o.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $gMc0m.default)([
                        status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
                    ])
                });
            }
        })
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $c7d700dd6b7beca2$var$RemovableTag = /*#__PURE__*/ (0, $42omo.memo)($c7d700dd6b7beca2$var$RemovableTagComponent);
var $c7d700dd6b7beca2$export$2e2bcd8739ae039 = $c7d700dd6b7beca2$var$RemovableTag;
module.exports["default"] = $c7d700dd6b7beca2$export$2e2bcd8739ae039;

});

parcelRegister("bpQ0v", function(module, exports) {
/* tag-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $beEBE = parcelRequire("beEBE");

const $35e59b02847d5a98$var$iconColorVar = '--ds-tag-icon';
const $35e59b02847d5a98$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};
const $35e59b02847d5a98$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _1rjcv77o _18zr1l7b _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _p12fmgvx _syazi7uo",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_1kxd1r31 _mod58stv _7acinqa1 _rlyhjdj5 _irr31dpa _1di6fcek"
}; // Border and icon color styles - each color sets CSS variables for its token values
const $35e59b02847d5a98$var$colorStyles = {
    gray: "_119b8yml _1ib21diz",
    blue: "_119b1w55 _1ib26txe",
    green: "_119b1crs _1ib217hp",
    red: "_119b16y8 _1ib2nbxb",
    yellow: "_119bfeiv _1ib21oqg",
    purple: "_119b1hqq _1ib2uq3u",
    lime: "_119bnf89 _1ib28645",
    magenta: "_119buwd0 _1ib2v8hk",
    orange: "_119b1b2s _1ib21j6y",
    teal: "_119b1h3o _1ib28uof"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ 
// Border + icon filter styles - base state
const $35e59b02847d5a98$var$borderIconFilterStyles = {
    root: "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _m71tr3uz _168qx19p _wi6h1o1e _4uq11yqs _u8p61h4e _hg5mr3uz _1t75u67f _1f28f1ug _189qkb7n _1easrqqc _1knhjbtf"
}; // Border + icon filter styles - interactive states (hover/pressed)
const $35e59b02847d5a98$var$borderIconInteractiveFilterStyles = {
    root: "_18dicjiy _hyog26zw _ylgq1r5k _bg3q9by0 _fdt01r5k _46v5hwvj _1iel6xdd _111i1h4e _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _196p1btq _18mn783i _4cvxpc7y _zqoikzix _q4zt1ij0 _ba351r2o _75gvn2k3 _kgu3swso _ui3h1vs5 _1r84p7hp"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ 
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ const $35e59b02847d5a98$var$TagNewComponent = /*#__PURE__*/ (0, $42omo.forwardRef)(function TagNew({ color: color = 'gray', text: text, elemBefore: elemBefore, href: href, linkComponent: linkComponent, isRemovable: isRemovable = true, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, ...other }, ref) {
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $beEBE.useTagRemoval)(text, onBeforeRemoveAction, onAfterRemoveAction);
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $beEBE.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $beEBE.useButtonInteraction)();
    const removeButton = (0, $beEBE.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: text,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    const tagContent = /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        ...other,
        ref: ref,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $35e59b02847d5a98$var$styles.baseStyles,
            $35e59b02847d5a98$var$colorStyles[color],
            $35e59b02847d5a98$var$borderIconFilterStyles.root,
            isLink && $35e59b02847d5a98$var$styles.interactiveBaseStyles,
            isLink && $35e59b02847d5a98$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $35e59b02847d5a98$var$borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && $35e59b02847d5a98$var$styles.interactiveHoverStyles,
            isRemovable && $35e59b02847d5a98$var$styles.removableStyles,
            isLinkFocused && !isButtonFocused && $35e59b02847d5a98$var$styles.childFocusRingStyles
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $beEBE.LinkWrapper), {
                isLink: isLink,
                href: href,
                LinkComponent: LinkComponent,
                testId: testId,
                linkHandlers: linkHandlers,
                children: [
                    elemBefore && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        className: (0, $gMc0m.default)([
                            $35e59b02847d5a98$var$styles.beforeStyles
                        ]),
                        children: elemBefore
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        className: (0, $gMc0m.default)([
                            $35e59b02847d5a98$var$styles.textStyles
                        ]),
                        children: text
                    })
                ]
            }),
            removeButton && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $35e59b02847d5a98$var$styles.afterStyles
                ]),
                children: removeButton
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $beEBE.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        children: tagContent
    });
}); /**
     * __Tag new__
     */ 
const $35e59b02847d5a98$var$TagNew = /*#__PURE__*/ (0, $42omo.memo)($35e59b02847d5a98$var$TagNewComponent);
var $35e59b02847d5a98$export$2e2bcd8739ae039 = $35e59b02847d5a98$var$TagNew;
module.exports["colorMapping"] = $35e59b02847d5a98$export$3351a8d90bcc13aa;
module.exports["default"] = $35e59b02847d5a98$export$2e2bcd8739ae039;

});

parcelRegister("8dG3J", function(module, exports) {
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $c594c0560f0f9d56$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
const $c594c0560f0f9d56$var$baseStyles = null;
const $c594c0560f0f9d56$var$interactiveStyles = null;
const $c594c0560f0f9d56$var$focusRingStyles = null;
const $c594c0560f0f9d56$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        className: (0, $gMc0m.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $c594c0560f0f9d56$var$borderColors[color],
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $c594c0560f0f9d56$export$2e2bcd8739ae039 = $c594c0560f0f9d56$var$BaseTag;
module.exports["default"] = $c594c0560f0f9d56$export$2e2bcd8739ae039;

});

parcelRegister("kHF6o", function(module, exports) {
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $9081fbaab560dd68$var$beforeElementStyles = null;
const $9081fbaab560dd68$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9081fbaab560dd68$export$2e2bcd8739ae039 = $9081fbaab560dd68$var$Before;
module.exports["default"] = $9081fbaab560dd68$export$2e2bcd8739ae039;

});

parcelRegister("4009b", function(module, exports) {
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ const $ff09199a85d0bb87$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress'
};
function $ff09199a85d0bb87$export$4d9e331cafeacb9d(color) {
    return $ff09199a85d0bb87$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}
module.exports["getLozengeAppearance"] = $ff09199a85d0bb87$export$4d9e331cafeacb9d;

});

parcelRegister("lJT0z", function(module, exports) {
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2634609f11ac6695$var$baseStyles = null;
const $2634609f11ac6695$var$linkStyles = null;
const $2634609f11ac6695$var$hasAfterStyles = null;
const $2634609f11ac6695$var$Content = ({ isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $l998X.jsx)(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? `${testId}--link` : undefined,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ]),
        children: text
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $2634609f11ac6695$export$2e2bcd8739ae039 = $2634609f11ac6695$var$Content;
module.exports["default"] = $2634609f11ac6695$export$2e2bcd8739ae039;

});

parcelRegister("jCd35", function(module, exports) {
/* remove-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $hmuev = parcelRequire("hmuev");


var $fVUfS = parcelRequire("fVUfS");

const $ee677bd76e709ca8$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _1bsb7vkz _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf"
};
const $ee677bd76e709ca8$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
const $ee677bd76e709ca8$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, testId: testId, shape: shape = 'default' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($ee677bd76e709ca8$var$removeButtonStyles.root, shape === 'circle' && $ee677bd76e709ca8$var$removeButtonStyles.circle, $ee677bd76e709ca8$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ee677bd76e709ca8$export$2e2bcd8739ae039 = $ee677bd76e709ca8$var$RemoveButton;
module.exports["default"] = $ee677bd76e709ca8$export$2e2bcd8739ae039;

});

parcelRegister("beEBE", function(module, exports) {
/* shared.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $2Nwuj = parcelRequire("2Nwuj");


var $g9Srd = parcelRequire("g9Srd");

var $8DMug = parcelRequire("8DMug");


var $jCd35 = parcelRequire("jCd35");

const $f1fc8226d432aba0$export$203775b632e10448 = '--ds-tag-icon';
const $f1fc8226d432aba0$export$7d6deb4aa4b5840e = '--tag-border-token';
const $f1fc8226d432aba0$export$df7ff9c2f76bffcd = '--tag-icon-token';
var $f1fc8226d432aba0$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});
const $f1fc8226d432aba0$export$279e7025ed114474 = ()=>true;
const $f1fc8226d432aba0$export$8793edee2d425525 = (0, $ee7An.default);
function $f1fc8226d432aba0$export$f26019543e9f862f(text, onBeforeRemoveAction, onAfterRemoveAction) {
    const [status, setStatus] = (0, $42omo.useState)("showing");
    const handleRemoveComplete = (0, $42omo.useCallback)(()=>{
        (onAfterRemoveAction ?? $f1fc8226d432aba0$export$8793edee2d425525)(text);
        setStatus("removed");
    }, [
        onAfterRemoveAction,
        text
    ]);
    const handleRemoveRequest = (0, $42omo.useCallback)(()=>{
        const beforeAction = onBeforeRemoveAction ?? $f1fc8226d432aba0$export$279e7025ed114474;
        if (beforeAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $42omo.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $42omo.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $42omo.useCallback)(()=>setStatus("showing"), []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}
function $f1fc8226d432aba0$export$dcf14c9974fe2767(href, linkComponent) {
    const isLink = Boolean(href);
    const LinkComponent = linkComponent ?? (0, $2Nwuj.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}
function $f1fc8226d432aba0$export$84acd183858d8235() {
    const [isLinkHovered, setIsLinkHovered] = (0, $42omo.useState)(false);
    const [isOverButton, setIsOverButton] = (0, $42omo.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, $42omo.useState)(false);
    const [isLinkFocused, setIsLinkFocused] = (0, $42omo.useState)(false);
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    const hadMouseDownRef = (0, $42omo.useRef)(false);
    // Button handlers
    const buttonHandlers = (0, $42omo.useMemo)(()=>({
            onMouseEnter: ()=>setIsOverButton(true),
            onMouseLeave: ()=>setIsOverButton(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsButtonFocused(false)
        }), []);
    // Link handlers - includes hover tracking
    const linkHandlers = (0, $42omo.useMemo)(()=>({
            onMouseEnter: ()=>setIsLinkHovered(true),
            onMouseLeave: ()=>setIsLinkHovered(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsLinkFocused(false)
        }), []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}
function $f1fc8226d432aba0$export$97d8be09cd53869b({ isRemovable: isRemovable, tagText: tagText, removeButtonLabel: removeButtonLabel, testId: testId, handleRemoveRequest: handleRemoveRequest, removingTag: removingTag, showingTag: showingTag, onKeyPress: onKeyPress, shape: shape = 'default', buttonHandlers: buttonHandlers }) {
    const handleFocus = (0, $42omo.useCallback)(()=>{
        removingTag();
        buttonHandlers?.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    const handleBlur = (0, $42omo.useCallback)(()=>{
        showingTag();
        buttonHandlers?.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $42omo.useMemo)(()=>{
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $jCd35.default), {
            "aria-label": `${removeButtonLabel || 'Remove'} ${tagText}`,
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers?.onMouseEnter,
            onMouseLeave: buttonHandlers?.onMouseLeave,
            onMouseDown: buttonHandlers?.onMouseDown,
            testId: testId ? `close-button-${testId}` : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}
function $f1fc8226d432aba0$export$898a500849bb5cf4({ isRemovable: isRemovable, status: status, children: children }) {
    if (isRemovable) return /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $l998X.jsx)((0, $8DMug.default), {
            children: (motion)=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
                    ref: motion.ref,
                    children: children
                })
        })
    });
    return children;
}
function $f1fc8226d432aba0$export$ce4b6a469c26f53f({ isLink: isLink, href: href, LinkComponent: LinkComponent, testId: testId, children: children, linkHandlers: linkHandlers }) {
    if (isLink && href) return /*#__PURE__*/ (0, $l998X.jsx)(LinkComponent, {
        href: href,
        testId: testId ? `${testId}--link` : undefined,
        onMouseEnter: linkHandlers?.onMouseEnter,
        onMouseLeave: linkHandlers?.onMouseLeave,
        onMouseDown: linkHandlers?.onMouseDown,
        onFocus: linkHandlers?.onFocus,
        onBlur: linkHandlers?.onBlur,
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: children
    });
}
module.exports["useTagRemoval"] = $f1fc8226d432aba0$export$f26019543e9f862f;
module.exports["useLink"] = $f1fc8226d432aba0$export$dcf14c9974fe2767;
module.exports["useButtonInteraction"] = $f1fc8226d432aba0$export$84acd183858d8235;
module.exports["useRemoveButton"] = $f1fc8226d432aba0$export$97d8be09cd53869b;
module.exports["RemovableWrapper"] = $f1fc8226d432aba0$export$898a500849bb5cf4;
module.exports["LinkWrapper"] = $f1fc8226d432aba0$export$ce4b6a469c26f53f;

});


$parcel$global.rlb("Wowvf")
//# sourceMappingURL=vendors~editor_atlaskit_sm.97b0fe1a.js.map
